function showMore() {
    const moreLinks = document.querySelectorAll('.js-more');
    if (moreLinks.length > 0) {
        const sectionBlock = moreLinks[0].closest('.js-more-section'),
            descriptionBlocks = document.querySelectorAll('.js-description');
        sectionBlock.addEventListener('click', function(e) {
            if (e.target.classList.contains('js-more')) {
                descriptionBlocks.forEach(item => {
                    if (!item.classList.contains('text-closed')) {
                        item.classList.add('text-closed');
                    }
                    
                });
                //console.log(this.previousElementSibling);
                e.target.previousElementSibling.classList.toggle('text-closed');
            }
        });
    }
}

export default showMore;